<style lang="scss" scoped>
@import '$vars';

a {
  position: fixed;
  bottom: 0;
  right: 2em;
  background: $color-red;
  padding: 5px 15px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: white;
  box-shadow: -4px 5px 5px rgba(0,0,0,0.3);
  font-size: 0.7rem;
  display: flex;
  text-decoration: none;
  z-index: 10;
}
p {
  margin: 0
}
figure {
  width: 1.5em;
}
</style>

<template>
  <pre :key="tick" class="d-inline" :id="getActiveAppointment">{{getTimer}}</pre>
</template>

<script>
import * as workerInterval from 'worker-interval'

export default {
  props: ['appointmentId'],
  data () {
    return {
      loaded: false,
      appointment: null,
      timerInterval: null,
      tick: 0,
      timer: {
        hours: 0,
        minutes: 0,
        seconds: 0
      }
    }
  },
  computed: {
    getActiveAppointment () {
      if (!this.$store.getters.getActiveAppointments[0]) {
        this.resetTimer()
        return
      }
      this.startTimer(this.$store.getters.getActiveAppointments[0])
      return this.$store.getters.getActiveAppointments[0].id || null
    },
    getTimer () {
      function addZero (v) {
        return v < 10 ? '0' + v : v
      }
      if (this.appointmentId) {
        if (this.getActiveAppointment !== this.appointmentId) {
          return '00:00:00'
        }
      }
      return `${addZero(this.timer.hours)}:${addZero(this.timer.minutes)}:${addZero(this.timer.seconds)}`
    }
  },
  watch: {
    '$route': function () {
      this.checkTick()
    }
  },
  methods: {
    checkTick () {
      this.tick = 1 + (-1 * this.tick)
    },
    resetTimer () {
      this.timer = {
        hours: 0,
        minutes: 0,
        seconds: 0
      }
      this.$emit('stopped', true)
      workerInterval.clearInterval(this.timerInterval)
    },
    startTimer (appointment) {
      const self = this
      this.$emit('started', true)
      this.timerInterval = workerInterval.setInterval(() => {
        let finish = this.$moment(new Date()).format()
        let start = this.$moment(appointment.medical_consultation_start).format()
        let time = this.$moment(finish).diff(start, 'seconds')
        let hours = Math.floor(time / 3600)
        let minutes = Math.floor(time / 60 - (hours * 60))
        let seconds = Math.floor(time - (hours * 3600) - (minutes * 60))
        self.timer = {
          hours,
          minutes,
          seconds
        }
        let timer = self.timer
        self.checkTick()
        if (timer.seconds === 59) {
          timer.seconds = 0
          if (timer.minutes === 59) {
            timer.minutes = 0
            timer.hours++
          } else {
            timer.minutes++
          }
        } else {
          timer.seconds++
        }
      }, 1000)
    }
  },
  beforeDestroy () {
    workerInterval.clearInterval(this.timerInterval)
  }
}
</script>
